import React from 'react';

const Resource = () => {
    return (
        <div>
            <section className="dark:bg-gray-800 dark:text-gray-100">
	<div className="container flex flex-col items-center p-4 mx-auto md:p-8">
		<h1 className="text-3xl font-bold leadi bg-green-300 text-center sm:text-4xl">Resource Center</h1>
		<div className="relative mt-6 mb-12">
			<span className="absolute inset-y-0 flex items-center pl-2 mx-auto">
				<button type="submit" title="Search" className="p-1 focus:outline-none focus:ring">
					<svg fill="currentColor" viewBox="0 0 512 512" className="w-4 h-4 dark:text-gray-100">
						<path d="M479.6,399.716l-81.084-81.084-62.368-25.767A175.014,175.014,0,0,0,368,192c0-97.047-78.953-176-176-176S16,94.953,16,192,94.953,368,192,368a175.034,175.034,0,0,0,101.619-32.377l25.7,62.2L400.4,478.911a56,56,0,1,0,79.2-79.195ZM48,192c0-79.4,64.6-144,144-144s144,64.6,144,144S271.4,336,192,336,48,271.4,48,192ZM456.971,456.284a24.028,24.028,0,0,1-33.942,0l-76.572-76.572-23.894-57.835L380.4,345.771l76.573,76.572A24.028,24.028,0,0,1,456.971,456.284Z"></path>
					</svg>
				</button>
			</span>
			<input type="search" name="Search" placeholder="Search..." className="w-full py-3 pl-12 text-sm rounded-full sm:w-96 focus:outline-none dark:bg-gray-800 dark:text-gray-100 focus:dark:bg-gray-900" />
		</div>
		<div className="flex flex-col w-full divide-y sm:flex-row sm:divide-y-0 sm:divide-x sm:px-8 lg:px-12 xl:px-32 divide-gray-700">
			<div className="flex flex-col w-full divide-y divide-gray-700">
				<a rel="noopener noreferrer" href="https://pdfhost.io/v/4FHTfFCas_MasterSQLin16Pages" className="flex items-center bg-success justify-center p-4 sm:py-8 lg:py-12">Master Of SQL</a>
				<a rel="noopener noreferrer" href="https://dotnettutorials.net/course/linq/" className="flex items-center bg-rose-300 justify-center p-4 sm:py-8 lg:py-12">LinQ Tutorial Pdf</a>
				<a rel="noopener noreferrer" href="https://www.youtube.com/watch?v=x8GRDuXy5tI&list=PLaFzfwmPR7_IZuwiT6nqcvNEhKl_Mg19A" className="flex items-center bg-red-600 justify-center p-4 sm:py-8 lg:py-12">LinQ Tutorial Video</a>
			</div>
			<div className="flex flex-col w-full divide-y divide-gray-700">
				<a rel="noopener noreferrer" href="https://pdfhost.io/v/6Q~Ol3s.x_30tipsfordotnetdeveloper" className="flex items-center bg-purple-500 justify-center p-4 sm:py-8 lg:py-12">30 Tips Of Asp.net Developers</a>
				<a rel="noopener noreferrer" href="#" className="flex items-center justify-center p-4 sm:py-8 lg:py-12">ComingSoon </a>
				<a rel="noopener noreferrer" href="#" className="flex items-center justify-center p-4 sm:py-8 lg:py-12">ComingSoon</a>
			</div>
			<div className="flex flex-col w-full divide-y divide-gray-700">
				<a rel="noopener noreferrer" href="https://pdfhost.io/v/PGDDq0abd_visualstudiorefactoringtips" className="flex items-center bg-blue-500 justify-center p-4 sm:py-8 lg:py-12">Visual Studio Refactoring Tips</a>
				<a rel="noopener noreferrer" href="#" className="flex items-center justify-center p-4 sm:py-8 lg:py-12">ComingSoon</a>
				<a rel="noopener noreferrer" href="#" className="flex items-center justify-center p-4 sm:py-8 lg:py-12">ComingSoon</a>
			</div>
		</div>
	</div>
</section>
        </div>
    );
};

export default Resource;